import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { formatDate } from 'date-fns'
import { toast } from 'sonner'

export default function useRemoveTransactionCategoryFromGroup({
  // setError = null,
  // clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    id,
    sortOrder,
  }: {
    id: string | number
    sortOrder: number
  }) => {
    const response = await httpClient.post(
      `/team/transaction-category/${id}/remove-from-group`,
    )

    await httpClient.put(`team/transaction-category/sort-order`, {
      id,
      entity_type: 'transaction_categories',
      sort_order: sortOrder,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Removed from the group')
      queryClient.invalidateQueries({ queryKey: ['transaction-categories'] })
    },
    onError: (error, variables) =>
      toast.error(error?.response?.data?.message ?? 'An error occurred.'),

    // handleFormError({
    //   error,
    //   variables,
    //   setError,
    //   clientServerFieldMapping,
    // }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
